  <!-- sidebar-cart -->
  <div id="sitebar-cart" class="sitebar-cart">
    <sitebar-cart></sitebar-cart>
  </div>
<!-- <app-header></app-header> -->

<app-navbar></app-navbar>
<div class="page-wrapper">
 <router-outlet></router-outlet>
 <!-- <app-founder-msg></app-founder-msg>
 <app-contact-us></app-contact-us> -->
<app-footer></app-footer>
</div>
